import { Metadata } from '@thro-types/billing';

import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const metadataSettingsValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    key: yup.string().required(t(translations.validation.required())).trim(),
    value: yup.string().required(t(translations.validation.required())).trim()
  });

export const useMetadataSettingsInitialValue = (metadata: Metadata | undefined) => {
  return metadata
    ? {
        key: metadata.key,
        value: metadata.value
      }
    : {
        key: undefined,
        value: undefined
      };
};
